<template>
  <div class="outer-box">
    <h4>Migrate To LC Email</h4>

    <div class="inner-box" style="text-align: left; width: 500px;">
      <select class="hl_input--wrap" type="text" v-model="feature">
        <option value="locationId">Location</option>
        <option value="companyId">Company</option>
      </select>
      <input class="mt-4 hl_input--wrap " type="text" placeholder="Location/Agency ID" v-model="documentId" />
      <button class="btn btn-primary mt-4" @click="migrateToLcEmail" :disabled="!documentId || isLoading">
        <moon-loader v-if="isLoading" :loading="true" size="21px" color="#fafafa" />
        <span v-else class="capitalize">Migrate</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { EmailISVService } from '@/services';

export default {
  name: "enable-blocked-features",
  data() {
    return {
      documentId: "",
      feature: 'locationId',
      response: null,
      isLoading: false
    };
  },
  methods: {
    migrateToLcEmail() {
			this.isLoading = true;
			EmailISVService.migrateToLcEmail(this.documentId, this.feature)
				.then((response) => {
					this.response = response.data;
				})
				.catch((error) => {
					this.response = error.response.data;
				})
				.finally(() => {
					this.isLoading = false;
				});
		}
  }
};
</script>

<style scoped>
 .capitalize {
  text-transform: capitalize;
 }
</style>
